// pages array, modify or add new tabs here 
export const pages = [
  { index: 0, name: 'overview.md', route: '/overview' },
  { index: 1, name: 'skills.md', route: '/skills' },
  { index: 2, name: 'projects.md', route: '/projects' },
  { index: 3, name: 'accomplishments.md', route: '/accomplishments' },
  { index: 4, name: 'resume.md', route: '/resume' },
];
